export const stripAuthParams = () => {
  const hash = window.location.hash;
  const hasRoute = hash && hash !== '#' && hash !== '#/';
  const hasCode = window.location.search.includes('code=');

  if (hasCode) {
    // remove everything from ? up to the # (or end), keep the hash route intact
    const cleaned = window.location.pathname + (hasRoute ? hash : '');
    window.history.replaceState({}, document.title, cleaned);
  }
};
